import {
    queryDistributionConfig,
    queryCrossborderConfig,
    editDistributionConfig,
    editCrossborderConfig,
    getKuaishouTemplateList,
    getDouyinTemplateList,
    getDouyinGxTemplateList,
    getSortRules,
    updateSortRules,
    getPinTemplateList,
    getJdTemplateList,
    getTaobaoTemplateList,
    getTmallTemplateList,
    scmSyncErp,
    setScmSyncErp,
    getTaoTeTemplateList,
    getYzTemplateList,
    getWxxdTemplateList,
    scmCompanyConfQuery,
    scmCompanyConfCacheQuery,
    scmCompanyConfSet,
    querySyncFiledConfig,
    editSyncConfig,
    getWdTemplateListApi,
    exemptionOtherPlatApi,
} from '@api/prod/conf/index';
import {
    getWxhAddressList,
    getWxhTemplateList
} from '@api/prod/center/index';

export function getDistributionConfig(data = {}) {
    return queryDistributionConfig(data).then((res) => {
        if (res.result === 1) {
            return res.data || {};
        }
        return {};
    })
}
export function getCrossborderConfig(data = {}) {
    return queryCrossborderConfig(data).then((res) => {
        if (res.result === 1) {
            return res.data || {};
        }
        return {};
    })
}
export function updateDistributionConfig(data = {}) {
    return editDistributionConfig(data).then((res) => {
        if (res.result === 1) {
            return true;
        }
        return false
    })
}
export function saveCrossborderConfig(data = {}) {
    return editCrossborderConfig(data).then((res) => {
        if (res.result === 1) {
            return true;
        }
        return false
    })
}

export function getWxsphTemplateList(data = {}) {
    return getWxhTemplateList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data|| []
        }
    })
}

/*
 * 获取微信视频号退货地址接口信息
 * 
 * @export
 * @param {any} [data={}] 
 * @returns 
* */
export function getWxsphAddressList(data = {}) {
    return getWxhAddressList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data|| []
        }
    })
}

export function getKSTemplateList(data = {}) {
    return getKuaishouTemplateList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data.expressTemplateDetailVOS || []
        }
    })
}
export function getWeixxdTemplateList(data = {}) {
    return getWxxdTemplateList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data || []
        }
    })
}
export function getFxgTemplateList(data = {}) {
    return getDouyinTemplateList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data.list || []
        }
        return []
    })
}
export function getFxgGxTemplateList(data = {}) {
    return getDouyinGxTemplateList(data).then(res => {
        if (res.result === 1) {
            return res?.data?.data?.list || []
        }
        return []
    })
}
export function getTBTemplateList(data = {}) {
    return getTaobaoTemplateList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data || []
        }
    })
}

export function getTTeTemplateList(data = {}) {
    return getTaoTeTemplateList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data || []
        }
    })
}

export function getTMTemplateList(data = {}) {
    return getTmallTemplateList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data || []
        }
    })
}
export function getPddTemplateList(data = {}) {
    return getPinTemplateList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data || []
        }
    })
}

export function getJdTemplates(data = {}, config = {}) {
    return getJdTemplateList(data, config).then(res => {
        if (res.result === 1) {
            return res.data || []
        }
        return false
    })
}

export function getYouZanTemplates(data = {}) {
    return getYzTemplateList(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data || []
        }
    })
}

export function getSortRulesData() {
    return getSortRules().then(res => {
        if (res.result === 1 && res.data) {
            res.data.length >= 0 && res.data.sort((m, n) => m['ruleNo'] - n['ruleNo'])
            return res.data || []
        }
    })
}

export function editSortRules(data) {
    return updateSortRules(data).then(res => {
        if (res.result === 1 && res.data) {
            return res || []
        }
    })
}

export function getSyncErp() {
    return scmSyncErp().then(res => {
        if (res.result === 1) {
            return res.data === 1 ? true : false
        }
    })
}

export function setSyncErp(bool) {
    return setScmSyncErp({itemSyncErp: bool ? 1 : 0}).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}

export function getScmCompanyConf() {
    return scmCompanyConfQuery().then(res => {
        if (res.result === 1) {
            return {
                ...res.data,
                pushItemToErp: [0, 1].includes(res.data.pushItemToErp) ? res.data.pushItemToErp : 1
            }
        }
    })
}
export function getScmCompanyConfCache() {
    return scmCompanyConfCacheQuery().then(res => {
        if (res.result === 1) {
            return {
                ...res.data,
                pushItemToErp: [0, 1].includes(res.data.pushItemToErp) ? res.data.pushItemToErp : 1
            }
        }
    })
}



export function setScmCompanyConf(data) {
    return scmCompanyConfSet(data).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}

// 查询商品同步管理字段配置
export function getSyncFiledConfig(data) {
    return querySyncFiledConfig(data).then(res => {
        if (res.result === 1) {
            return res.data || {};
        } 
    })
}
// 更新商品同步管理字段配置
export function editSyncFiledConfig(data) {
    return editSyncConfig(data).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}

export function getWdTemplateList(data = {}) {
    return getWdTemplateListApi(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data|| []
        }
    })
}

export function exemptionOtherPlat(data = {}) {
    return exemptionOtherPlatApi(data).then(res => {
        if (res.result === 1 && res.data) {
            return res.data|| []
        }
    })
}

